// `text.actor_description`: an actor's description from its portrait, a step of the Advanced
// Talking Head's run (#223, step A'). Live lists no such job; the run starts it.
import {
  TextActorDescriptionQuote,
  TextActorDescriptionRequest,
} from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"text.actor_description"> = {
  type: "text.actor_description",
  label: "Actor description",
  source: "form",
  pair: "text.actor_description",
  fields: () => ({}),
  request: TextActorDescriptionRequest,
  quote: TextActorDescriptionQuote,
};
